(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('AdvertisementService', AdvertisementService)
	AdvertisementService.$inject = ['$http']
	function AdvertisementService($http){
		var service = {
			getAllAdvertisementsByParent:getAllAdvertisementsByParent,
			getAllAdvertisementsByProperty:getAllAdvertisementsByProperty,
			getAdvertisementsByScope:getAdvertisementsByScope,
			getAllAdvertisements:getAllAdvertisements,
			getAdvertisement:getAdvertisement,
			getAdvertisementSummary:getAdvertisementSummary,
			addAdvertisement:addAdvertisement,
			attachAdvertisementToParent:attachAdvertisementToParent,
			detachAdvertisementFromParent:detachAdvertisementFromParent,
			updateAdvertisement:updateAdvertisement,
			deleteAdvertisement:deleteAdvertisement
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/
		function getAllAdvertisementsByParent(parentId,parentType){
			return $http.get('/api/advertisements-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAllAdvertisementsByProperty(propertyName,propertyValue){
			return $http.get('/api/advertisements-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAdvertisementsByScope(scopeName, count, queryParam, queryParam1) {
			var url = '/api/advertisements-by-scope/' + scopeName;
			if ((count != undefined) && (count != '')) {
				url = url + '/' + count;
			}
			if ((queryParam != undefined) && (queryParam != '')) {
				url = url + '/' + queryParam;
			}
			if ((queryParam1 != undefined) && (queryParam1 != '')) {
				url = url + '/' + queryParam1;
			}
			return $http.get(url)
			.then(function (response) {
				if (response.status == 200) {
					return response.data.payload;
				} else {
					console.error("ERROR, Non-200 status received in getAdvertisementsByScope: ", response);
				}
			})
			.catch(function (err) {
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllAdvertisements(q,count){
			q = q || "";
			count = count || 1000;
			var url = '/api/all-advertisements';
			if ((count != '')&&(q != '')) {
				url = url + '/' + q + '/' + count;
			}else if (q != '') {
				url = url + '/' + q;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAdvertisement(advertisementId){
			return $http.get('/api/advertisement/' + advertisementId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAdvertisementSummary(parentId,parentType){
			return $http.get('/api/advertisement/'+ parentId +'/'+parentType+'/summary')
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function addAdvertisement(data){
			return $http.post('/api/advertisement', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function updateAdvertisement(advertisementId, data){
			return $http.put('/api/advertisement/' + advertisementId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};


		function attachAdvertisementToParent(data){
			return $http.post('/api/attach-advertisement-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function detachAdvertisementFromParent(data){
			return $http.post('/api/detach-advertisement-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function deleteAdvertisement(advertisementId, data){
			return $http.delete('/api/advertisement/' + advertisementId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('AdvertiserService', AdvertiserService)
	AdvertiserService.$inject = ['$http']
	function AdvertiserService($http){
		var service = {
			getAllAdvertisersByParent:getAllAdvertisersByParent,
			getUnassociatedAdvertisersByParent:getUnassociatedAdvertisersByParent,
			getAllAdvertisersByProperty:getAllAdvertisersByProperty,
			getAdvertisersByScope:getAdvertisersByScope,
			getAllAdvertisers:getAllAdvertisers,
			getOrphanedAdvertisers:getOrphanedAdvertisers,
			getAdvertiser:getAdvertiser,
			addAdvertiser:addAdvertiser,
			bulkAttachAdvertiserToParent:bulkAttachAdvertiserToParent,
			attachAdvertiserToParent:attachAdvertiserToParent,
			detachAdvertiserFromParent:detachAdvertiserFromParent,
			updateAdvertiser:updateAdvertiser,
			deleteAdvertiser:deleteAdvertiser
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/
		function getAllAdvertisersByParent(parentId,parentType){
			return $http.get('/api/advertisers-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getUnassociatedAdvertisersByParent(parentId,parentType){
			return $http.get('/api/unassociated-advertisers-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAllAdvertisersByProperty(propertyName,propertyValue){
			return $http.get('/api/advertisers-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAdvertisersByScope(scopeName, count, queryParam, queryParam1) {
			var url = '/api/advertisers-by-scope/' + scopeName;
			if ((count != undefined) && (count != '')) {
				url = url + '/' + count;
			}
			if ((queryParam != undefined) && (queryParam != '')) {
				url = url + '/' + queryParam;
			}
			if ((queryParam1 != undefined) && (queryParam1 != '')) {
				url = url + '/' + queryParam1;
			}
			return $http.get(url)
			.then(function (response) {
				if (response.status == 200) {
					return response.data.payload;
				} else {
					console.error("ERROR, Non-200 status received in getAdvertisersByScope: ", response);
				}
			})
			.catch(function (err) {
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllAdvertisers(q,count){
			q = q || "";
			count = count || 1000;
			var url = '/api/all-advertisers';
			if ((count != '')&&(q != '')) {
				url = url + '/' + q + '/' + count;
			}else if (q != '') {
				url = url + '/' + q;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getOrphanedAdvertisers(){
			return $http.get('/api/orphaned-advertisers')
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAdvertiser(advertiserId){
			return $http.get('/api/advertiser/' + advertiserId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function addAdvertiser(data){
			return $http.post('/api/advertiser', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function bulkAttachAdvertiserToParent(data){
			return $http.post('/api/advertiser/attach-bulk', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function updateAdvertiser(advertiserId, data){
			return $http.put('/api/advertiser/' + advertiserId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};


		function attachAdvertiserToParent(data){
			return $http.post('/api/attach-advertiser-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function detachAdvertiserFromParent(data){
			return $http.post('/api/detach-advertiser-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function deleteAdvertiser(advertiserId, data){
			return $http.delete('/api/advertiser/' + advertiserId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.service('fileUpload', ['$http', function ($http) {
	this.uploadFileToUrl = function(file, uploadUrl, addons){
		console.log("ADDONS", addons);
		var fd = new FormData();
		fd.append('file', file);
		if(addons != undefined){
			fd.append('_token', addons._token);
			fd.append('parentType', addons.parentType);
			fd.append('parentId', addons.parentId);
			fd.append('description', addons.description);
			fd.append('category', addons.category);
		}
		return $http.post(uploadUrl, fd, {
			transformRequest: angular.identity,
			headers: {'Content-Type': undefined}
		});
	}
}]) 
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('IssueService', IssueService)
	IssueService.$inject = ['$http']
	function IssueService($http){
		var service = {
			getAllIssuesByParent:getAllIssuesByParent,
			getAllIssuesByProperty:getAllIssuesByProperty,
			getIssuesByScope:getIssuesByScope,
			getAllIssues:getAllIssues,
			getIssue:getIssue,
			addIssue:addIssue,
			attachIssueToParent:attachIssueToParent,
			detachIssueFromParent:detachIssueFromParent,
			updateIssue:updateIssue,
			deleteIssue:deleteIssue
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/
		function getAllIssuesByParent(parentId,parentType){
			return $http.get('/api/issues-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAllIssuesByProperty(propertyName,propertyValue){
			return $http.get('/api/issues-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getIssuesByScope(scopeName, count, queryParam, queryParam1) {
			var url = '/api/issues-by-scope/' + scopeName;
			if ((count != undefined) && (count != '')) {
				url = url + '/' + count;
			}
			if ((queryParam != undefined) && (queryParam != '')) {
				url = url + '/' + queryParam;
			}
			if ((queryParam1 != undefined) && (queryParam1 != '')) {
				url = url + '/' + queryParam1;
			}
			return $http.get(url)
			.then(function (response) {
				if (response.status == 200) {
					return response.data.payload;
				} else {
					console.error("ERROR, Non-200 status received in getIssuesByScope: ", response);
				}
			})
			.catch(function (err) {
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllIssues(q,count){
			q = q || "";
			count = count || 1000;
			var url = '/api/all-issues';
			if ((count != '')&&(q != '')) {
				url = url + '/' + q + '/' + count;
			}else if (q != '') {
				url = url + '/' + q;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getIssue(issueId){
			return $http.get('/api/issue/' + issueId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function addIssue(data){
			return $http.post('/api/issue', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function updateIssue(issueId, data){
			return $http.put('/api/issue/' + issueId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};


		function attachIssueToParent(data){
			return $http.post('/api/attach-issue-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function detachIssueFromParent(data){
			return $http.post('/api/detach-issue-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function deleteIssue(issueId, data){
			return $http.delete('/api/issue/' + issueId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('PremiumspotService', PremiumspotService)
	PremiumspotService.$inject = ['$http']
	function PremiumspotService($http){
		var service = {
			getAllPremiumspotsByParent:getAllPremiumspotsByParent,
			getAllPremiumspotsByProperty:getAllPremiumspotsByProperty,
			getPremiumspotsByScope:getPremiumspotsByScope,
			getAllPremiumspots:getAllPremiumspots,
			getPremiumspot:getPremiumspot,
			addPremiumspot:addPremiumspot,
			attachPremiumspotToParent:attachPremiumspotToParent,
			detachPremiumspotFromParent:detachPremiumspotFromParent,
			updatePremiumspot:updatePremiumspot,
			deletePremiumspot:deletePremiumspot
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/
		function getAllPremiumspotsByParent(parentId,parentType){
			return $http.get('/api/premiumspots-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAllPremiumspotsByProperty(propertyName,propertyValue){
			return $http.get('/api/premiumspots-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getPremiumspotsByScope(scopeName, count, queryParam, queryParam1) {
			var url = '/api/premiumspots-by-scope/' + scopeName;
			if ((count != undefined) && (count != '')) {
				url = url + '/' + count;
			}
			if ((queryParam != undefined) && (queryParam != '')) {
				url = url + '/' + queryParam;
			}
			if ((queryParam1 != undefined) && (queryParam1 != '')) {
				url = url + '/' + queryParam1;
			}
			return $http.get(url)
			.then(function (response) {
				if (response.status == 200) {
					return response.data.payload;
				} else {
					console.error("ERROR, Non-200 status received in getPremiumspotsByScope: ", response);
				}
			})
			.catch(function (err) {
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllPremiumspots(q,count){
			q = q || "";
			count = count || 1000;
			var url = '/api/all-premiumspots';
			if ((count != '')&&(q != '')) {
				url = url + '/' + q + '/' + count;
			}else if (q != '') {
				url = url + '/' + q;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getPremiumspot(premiumspotId){
			return $http.get('/api/premiumspot/' + premiumspotId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function addPremiumspot(data){
			return $http.post('/api/premiumspot', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function updatePremiumspot(premiumspotId, data){
			return $http.put('/api/premiumspot/' + premiumspotId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};


		function attachPremiumspotToParent(data){
			return $http.post('/api/attach-premiumspot-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function detachPremiumspotFromParent(data){
			return $http.post('/api/detach-premiumspot-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function deletePremiumspot(premiumspotId, data){
			return $http.delete('/api/premiumspot/' + premiumspotId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('ProspectService', ProspectService)
	ProspectService.$inject = ['$http']
	function ProspectService($http){
		var service = {
			getAllProspectsByParent:getAllProspectsByParent,
			getAllProspectsByProperty:getAllProspectsByProperty,
			getProspectsByScope:getProspectsByScope,
			getAllProspects:getAllProspects,
			getProspect:getProspect,
			addProspect:addProspect,
			attachProspectToParent:attachProspectToParent,
			detachProspectFromParent:detachProspectFromParent,
			updateProspect:updateProspect,
			deleteProspect:deleteProspect
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/
		function getAllProspectsByParent(parentId,parentType){
			return $http.get('/api/prospects-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllProspectsByProperty(propertyName,propertyValue){
			return $http.get('/api/prospects-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getProspectsByScope(scopeName, count, queryParam, queryParam1) {
			var url = '/api/prospects-by-scope/' + scopeName;
			if ((count != undefined) && (count != '')) {
				url = url + '/' + count;
			}
			if ((queryParam != undefined) && (queryParam != '')) {
				url = url + '/' + queryParam;
			}
			if ((queryParam1 != undefined) && (queryParam1 != '')) {
				url = url + '/' + queryParam1;
			}
			return $http.get(url)
			.then(function (response) {
				if (response.status == 200) {
					return response.data.payload;
				} else {
					console.error("ERROR, Non-200 status received in getProspectsByScope: ", response);
				}
			})
			.catch(function (err) {
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllProspects(q,count){
			q = q || "";
			count = count || 1000;
			var url = '/api/all-prospects';
			if ((count != '')&&(q != '')) {
				url = url + '/' + q + '/' + count;
			}else if (q != '') {
				url = url + '/' + q;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getProspect(prospectId){
			return $http.get('/api/prospect/' + prospectId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function addProspect(data){
			return $http.post('/api/prospect', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function updateProspect(prospectId, data){
			return $http.put('/api/prospect/' + prospectId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};


		function attachProspectToParent(data){
			return $http.post('/api/attach-prospect-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function detachProspectFromParent(data){
			return $http.post('/api/detach-prospect-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function deleteProspect(prospectId, data){
			return $http.delete('/api/prospect/' + prospectId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('PublicationService', PublicationService)
	PublicationService.$inject = ['$http']
	function PublicationService($http){
		var service = {
			getAllPublicationsByParent:getAllPublicationsByParent,
			getAllPublicationsByProperty:getAllPublicationsByProperty,
			getPublicationsByScope:getPublicationsByScope,
			getAllPublications:getAllPublications,
			getPublication:getPublication,
			addPublication:addPublication,
			attachPublicationToParent:attachPublicationToParent,
			detachPublicationFromParent:detachPublicationFromParent,
			updatePublication:updatePublication,
			deletePublication:deletePublication
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/
		function getAllPublicationsByParent(parentId,parentType){
			return $http.get('/api/publications-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAllPublicationsByProperty(propertyName,propertyValue){
			return $http.get('/api/publications-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getPublicationsByScope(scopeName, count, queryParam, queryParam1) {
			var url = '/api/publications-by-scope/' + scopeName;
			if ((count != undefined) && (count != '')) {
				url = url + '/' + count;
			}
			if ((queryParam != undefined) && (queryParam != '')) {
				url = url + '/' + queryParam;
			}
			if ((queryParam1 != undefined) && (queryParam1 != '')) {
				url = url + '/' + queryParam1;
			}
			return $http.get(url)
			.then(function (response) {
				if (response.status == 200) {
					return response.data.payload;
				} else {
					console.error("ERROR, Non-200 status received in getPublicationsByScope: ", response);
				}
			})
			.catch(function (err) {
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllPublications(q,count){
			q = q || "";
			count = count || 1000;
			var url = '/api/all-publications';
			if ((count != '')&&(q != '')) {
				url = url + '/' + q + '/' + count;
			}else if (q != '') {
				url = url + '/' + q;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getPublication(publicationId){
			return $http.get('/api/publication/' + publicationId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function addPublication(data){
			return $http.post('/api/publication', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function updatePublication(publicationId, data){
			return $http.put('/api/publication/' + publicationId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};


		function attachPublicationToParent(data){
			return $http.post('/api/attach-publication-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function detachPublicationFromParent(data){
			return $http.post('/api/detach-publication-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function deletePublication(publicationId, data){
			return $http.delete('/api/publication/' + publicationId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('PublisherService', PublisherService)
	PublisherService.$inject = ['$http']
	function PublisherService($http){
		var service = {
			getAllPublishersByParent:getAllPublishersByParent,
			getAllPublishersByProperty:getAllPublishersByProperty,
			getPublishersByScope:getPublishersByScope,
			getAllPublishers:getAllPublishers,
			getPublisher:getPublisher,
			addPublisher:addPublisher,
			attachPublisherToParent:attachPublisherToParent,
			detachPublisherFromParent:detachPublisherFromParent,
			updatePublisher:updatePublisher,
			deletePublisher:deletePublisher
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/
		function getAllPublishersByParent(parentId,parentType){
			return $http.get('/api/publishers-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAllPublishersByProperty(propertyName,propertyValue){
			return $http.get('/api/publishers-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getPublishersByScope(scopeName, count, queryParam, queryParam1) {
			var url = '/api/publishers-by-scope/' + scopeName;
			if ((count != undefined) && (count != '')) {
				url = url + '/' + count;
			}
			if ((queryParam != undefined) && (queryParam != '')) {
				url = url + '/' + queryParam;
			}
			if ((queryParam1 != undefined) && (queryParam1 != '')) {
				url = url + '/' + queryParam1;
			}
			return $http.get(url)
			.then(function (response) {
				if (response.status == 200) {
					return response.data.payload;
				} else {
					console.error("ERROR, Non-200 status received in getPublishersByScope: ", response);
				}
			})
			.catch(function (err) {
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllPublishers(q,count){
			q = q || "";
			count = count || 1000;
			var url = '/api/all-publishers';
			if ((count != '')&&(q != '')) {
				url = url + '/' + q + '/' + count;
			}else if (q != '') {
				url = url + '/' + q;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getPublisher(publisherId){
			return $http.get('/api/publisher/' + publisherId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function addPublisher(data){
			return $http.post('/api/publisher', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function updatePublisher(publisherId, data){
			return $http.put('/api/publisher/' + publisherId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};


		function attachPublisherToParent(data){
			return $http.post('/api/attach-publisher-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function detachPublisherFromParent(data){
			return $http.post('/api/detach-publisher-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function deletePublisher(publisherId, data){
			return $http.delete('/api/publisher/' + publisherId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('SocmedService', SocmedService)
	SocmedService.$inject = ['$http']
	function SocmedService($http){
		var service = {
			getAllSocmedsByParent:getAllSocmedsByParent,
			getAllSocmedsByProperty:getAllSocmedsByProperty,
			getSocmedsByScope:getSocmedsByScope,
			getAllSocmeds:getAllSocmeds,
			getSocmed:getSocmed,
			addSocmed:addSocmed,
			attachSocmedToParent:attachSocmedToParent,
			detachSocmedFromParent:detachSocmedFromParent,
			updateSocmed:updateSocmed,
			deleteSocmed:deleteSocmed
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/
		function getAllSocmedsByParent(parentId,parentType){
			return $http.get('/api/socmeds-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAllSocmedsByProperty(propertyName,propertyValue){
			return $http.get('/api/socmeds-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getSocmedsByScope(scopeName, count, queryParam, queryParam1) {
			var url = '/api/socmeds-by-scope/' + scopeName;
			if ((count != undefined) && (count != '')) {
				url = url + '/' + count;
			}
			if ((queryParam != undefined) && (queryParam != '')) {
				url = url + '/' + queryParam;
			}
			if ((queryParam1 != undefined) && (queryParam1 != '')) {
				url = url + '/' + queryParam1;
			}
			return $http.get(url)
			.then(function (response) {
				if (response.status == 200) {
					return response.data.payload;
				} else {
					console.error("ERROR, Non-200 status received in getSocmedsByScope: ", response);
				}
			})
			.catch(function (err) {
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllSocmeds(q,count){
			q = q || "";
			count = count || 1000;
			var url = '/api/all-socmeds';
			if ((count != '')&&(q != '')) {
				url = url + '/' + q + '/' + count;
			}else if (q != '') {
				url = url + '/' + q;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getSocmed(socmedId){
			return $http.get('/api/socmed/' + socmedId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function addSocmed(data){
			return $http.post('/api/socmed', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function updateSocmed(socmedId, data){
			return $http.put('/api/socmed/' + socmedId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};


		function attachSocmedToParent(data){
			return $http.post('/api/attach-socmed-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function detachSocmedFromParent(data){
			return $http.post('/api/detach-socmed-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function deleteSocmed(socmedId, data){
			return $http.delete('/api/socmed/' + socmedId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('SpotService', SpotService)
	SpotService.$inject = ['$http']
	function SpotService($http){
		var service = {
			getAllSpotsByParent:getAllSpotsByParent,
			getAllSpotsByProperty:getAllSpotsByProperty,
			getSpotsByScope:getSpotsByScope,
			getAllSpots:getAllSpots,
			getSpot:getSpot,
			addSpot:addSpot,
			attachSpotToParent:attachSpotToParent,
			detachSpotFromParent:detachSpotFromParent,
			updateSpot:updateSpot,
			deleteSpot:deleteSpot
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/
		function getAllSpotsByParent(parentId,parentType){
			return $http.get('/api/spots-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAllSpotsByProperty(propertyName,propertyValue){
			return $http.get('/api/spots-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getSpotsByScope(scopeName, count, queryParam, queryParam1) {
			var url = '/api/spots-by-scope/' + scopeName;
			if ((count != undefined) && (count != '')) {
				url = url + '/' + count;
			}
			if ((queryParam != undefined) && (queryParam != '')) {
				url = url + '/' + queryParam;
			}
			if ((queryParam1 != undefined) && (queryParam1 != '')) {
				url = url + '/' + queryParam1;
			}
			return $http.get(url)
			.then(function (response) {
				if (response.status == 200) {
					return response.data.payload;
				} else {
					console.error("ERROR, Non-200 status received in getSpotsByScope: ", response);
				}
			})
			.catch(function (err) {
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllSpots(q,count){
			q = q || "";
			count = count || 1000;
			var url = '/api/all-spots';
			if ((count != '')&&(q != '')) {
				url = url + '/' + q + '/' + count;
			}else if (q != '') {
				url = url + '/' + q;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getSpot(spotId){
			return $http.get('/api/spot/' + spotId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function addSpot(data){
			return $http.post('/api/spot', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function updateSpot(spotId, data){
			return $http.put('/api/spot/' + spotId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};


		function attachSpotToParent(data){
			return $http.post('/api/attach-spot-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function detachSpotFromParent(data){
			return $http.post('/api/detach-spot-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function deleteSpot(spotId, data){
			return $http.delete('/api/spot/' + spotId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('StageService', StageService)
	StageService.$inject = ['$http']
	function StageService($http){
		var service = {
			getAllStagesByParent:getAllStagesByParent,
			getAllStagesByProperty:getAllStagesByProperty,
			getStagesByScope:getStagesByScope,
			getAllStages:getAllStages,
			getStage:getStage,
			addStage:addStage,
			attachStageToParent:attachStageToParent,
			detachStageFromParent:detachStageFromParent,
			updateStage:updateStage,
			deleteStage:deleteStage
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/
		function getAllStagesByParent(parentId,parentType){
			return $http.get('/api/stages-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAllStagesByProperty(propertyName,propertyValue){
			return $http.get('/api/stages-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getStagesByScope(scopeName, count, queryParam, queryParam1) {
			var url = '/api/stages-by-scope/' + scopeName;
			if ((count != undefined) && (count != '')) {
				url = url + '/' + count;
			}
			if ((queryParam != undefined) && (queryParam != '')) {
				url = url + '/' + queryParam;
			}
			if ((queryParam1 != undefined) && (queryParam1 != '')) {
				url = url + '/' + queryParam1;
			}
			return $http.get(url)
			.then(function (response) {
				if (response.status == 200) {
					return response.data.payload;
				} else {
					console.error("ERROR, Non-200 status received in getStagesByScope: ", response);
				}
			})
			.catch(function (err) {
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllStages(q,count){
			q = q || "";
			count = count || 1000;
			var url = '/api/all-stages';
			if ((count != '')&&(q != '')) {
				url = url + '/' + q + '/' + count;
			}else if (q != '') {
				url = url + '/' + q;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getStage(stageId){
			return $http.get('/api/stage/' + stageId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function addStage(data){
			return $http.post('/api/stage', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function updateStage(stageId, data){
			return $http.put('/api/stage/' + stageId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};


		function attachStageToParent(data){
			return $http.post('/api/attach-stage-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function detachStageFromParent(data){
			return $http.post('/api/detach-stage-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function deleteStage(stageId, data){
			return $http.delete('/api/stage/' + stageId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('SubmissionService', SubmissionService)
	SubmissionService.$inject = ['$http']
	function SubmissionService($http){
		var service = {
			getAllSubmissionsByParent:getAllSubmissionsByParent,
			getAllSubmissionsByProperty:getAllSubmissionsByProperty,
			getSubmissionsByScope:getSubmissionsByScope,
			getAllSubmissions:getAllSubmissions,
			getSubmission:getSubmission,
			addSubmission:addSubmission,
			attachSubmissionToParent:attachSubmissionToParent,
			detachSubmissionFromParent:detachSubmissionFromParent,
			updateSubmission:updateSubmission,
			deleteSubmission:deleteSubmission
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/
		function getAllSubmissionsByParent(parentId,parentType){
			return $http.get('/api/submissions-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAllSubmissionsByProperty(propertyName,propertyValue){
			return $http.get('/api/submissions-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getSubmissionsByScope(scopeName, count, queryParam, queryParam1) {
			var url = '/api/submissions-by-scope/' + scopeName;
			if ((count != undefined) && (count != '')) {
				url = url + '/' + count;
			}
			if ((queryParam != undefined) && (queryParam != '')) {
				url = url + '/' + queryParam;
			}
			if ((queryParam1 != undefined) && (queryParam1 != '')) {
				url = url + '/' + queryParam1;
			}
			return $http.get(url)
			.then(function (response) {
				if (response.status == 200) {
					return response.data.payload;
				} else {
					console.error("ERROR, Non-200 status received in getSubmissionsByScope: ", response);
				}
			})
			.catch(function (err) {
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllSubmissions(q,count){
			q = q || "";
			count = count || 1000;
			var url = '/api/all-submissions';
			if ((count != '')&&(q != '')) {
				url = url + '/' + q + '/' + count;
			}else if (q != '') {
				url = url + '/' + q;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getSubmission(submissionId){
			return $http.get('/api/submission/' + submissionId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function addSubmission(data){
			return $http.post('/api/submission', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function updateSubmission(submissionId, data){
			return $http.put('/api/submission/' + submissionId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};


		function attachSubmissionToParent(data){
			return $http.post('/api/attach-submission-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function detachSubmissionFromParent(data){
			return $http.post('/api/detach-submission-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function deleteSubmission(submissionId, data){
			return $http.delete('/api/submission/' + submissionId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('TicketService', TicketService)
	TicketService.$inject = ['$http']
	function TicketService($http){
		var service = {
			getAllTicketsByParent:getAllTicketsByParent,
			getAllTicketsByProperty:getAllTicketsByProperty,
			getTicketsByScope:getTicketsByScope,
			getAllTickets:getAllTickets,
			getTicket:getTicket,
			addTicket:addTicket,
			attachTicketToParent:attachTicketToParent,
			detachTicketFromParent:detachTicketFromParent,
			updateTicket:updateTicket,
			deleteTicket:deleteTicket
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/
		function getAllTicketsByParent(parentId,parentType){
			return $http.get('/api/tickets-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAllTicketsByProperty(propertyName,propertyValue){
			return $http.get('/api/tickets-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getTicketsByScope(scopeName, count, queryParam, queryParam1) {
			var url = '/api/tickets-by-scope/' + scopeName;
			if ((count != undefined) && (count != '')) {
				url = url + '/' + count;
			}
			if ((queryParam != undefined) && (queryParam != '')) {
				url = url + '/' + queryParam;
			}
			if ((queryParam1 != undefined) && (queryParam1 != '')) {
				url = url + '/' + queryParam1;
			}
			return $http.get(url)
			.then(function (response) {
				if (response.status == 200) {
					return response.data.payload;
				} else {
					console.error("ERROR, Non-200 status received in getTicketsByScope: ", response);
				}
			})
			.catch(function (err) {
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllTickets(q,count){
			q = q || "";
			count = count || 1000;
			var url = '/api/all-tickets';
			if ((count != '')&&(q != '')) {
				url = url + '/' + q + '/' + count;
			}else if (q != '') {
				url = url + '/' + q;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getTicket(ticketId){
			return $http.get('/api/ticket/' + ticketId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function addTicket(data){
			return $http.post('/api/ticket', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function updateTicket(ticketId, data){
			return $http.put('/api/ticket/' + ticketId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};


		function attachTicketToParent(data){
			return $http.post('/api/attach-ticket-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function detachTicketFromParent(data){
			return $http.post('/api/detach-ticket-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function deleteTicket(ticketId, data){
			return $http.delete('/api/ticket/' + ticketId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('TickleService', TickleService)
	TickleService.$inject = ['$http']
	function TickleService($http){
		var service = {
			getAllTicklesByParent:getAllTicklesByParent,
			getAllTicklesByProperty:getAllTicklesByProperty,
			getTicklesByScope:getTicklesByScope,
			getAllTickles:getAllTickles,
			getTickle:getTickle,
			addTickle:addTickle,
			attachTickleToParent:attachTickleToParent,
			detachTickleFromParent:detachTickleFromParent,
			updateTickle:updateTickle,
			deleteTickle:deleteTickle
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/
		function getAllTicklesByParent(parentId,parentType){
			return $http.get('/api/tickles-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAllTicklesByProperty(propertyName,propertyValue){
			return $http.get('/api/tickles-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getTicklesByScope(scopeName, count, queryParam, queryParam1) {
			var url = '/api/tickles-by-scope/' + scopeName;
			if ((count != undefined) && (count != '')) {
				url = url + '/' + count;
			}
			if ((queryParam != undefined) && (queryParam != '')) {
				url = url + '/' + queryParam;
			}
			if ((queryParam1 != undefined) && (queryParam1 != '')) {
				url = url + '/' + queryParam1;
			}
			return $http.get(url)
			.then(function (response) {
				if (response.status == 200) {
					return response.data.payload;
				} else {
					console.error("ERROR, Non-200 status received in getTicklesByScope: ", response);
				}
			})
			.catch(function (err) {
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllTickles(q,count){
			q = q || "";
			count = count || 1000;
			var url = '/api/all-tickles';
			if ((count != '')&&(q != '')) {
				url = url + '/' + q + '/' + count;
			}else if (q != '') {
				url = url + '/' + q;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getTickle(tickleId){
			return $http.get('/api/tickle/' + tickleId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function addTickle(data){
			return $http.post('/api/tickle', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function updateTickle(tickleId, data){
			return $http.put('/api/tickle/' + tickleId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};


		function attachTickleToParent(data){
			return $http.post('/api/attach-tickle-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function detachTickleFromParent(data){
			return $http.post('/api/detach-tickle-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function deleteTickle(tickleId, data){
			return $http.delete('/api/tickle/' + tickleId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('UserService', UserService)
	UserService.$inject = ['$http']
	function UserService($http){
		return {
			getAllUsersByParent: getAllUsersByParent,
			getAllUsersByProperty: getAllUsersByProperty,
			getAllUsers: getAllUsers,
			getAllUserSimples: getAllUserSimples,
			getUsersLookup: getUsersLookup,
			getSearchUsers: getSearchUsers,
			getUser: getUser,
			addUser: addUser,
			reinviteUser: reinviteUser,
			updateUser: updateUser,
			updateUserRegister: updateUserRegister,
			updatePermissions: updatePermissions,
			attachRole: attachRole,
			detachRole: detachRole,
			attachUserToParent: attachUserToParent,
			detachUserFromParent: detachUserFromParent,
			deleteUser: deleteUser,
			getUnassociatedUsersByParent: getUnassociatedUsersByParent,
			getAllUsersByRole: getAllUsersByRole
		}
		function getAllUsersByParent(parentId,parentType){
			return $http.get('/api/users-by-parent/' + parentId + '/' + parentType)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getAllUsersByProperty(property1Name,property1Value){
			return $http.get('/api/all-users-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getAllUsers(){
			return $http.get('/api/all-users')
			.then(function(response){
				return {
					data: response.data.payload,
					count: response.data.count
				};
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getAllUserSimples(){
			return $http.get('/api/all-user-simples')
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getUsersLookup(){
			return $http.get('/api/users-lookup')
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getSearchUsers(){
			return $http.get('/api/search-users/' + parentId)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getUser(userId){
			return $http.get('/api/user/' + userId)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function addUser(data){
			return $http.post('/api/user', data)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function reinviteUser(userId){
			return $http.post('/api/reinvite-user/' + userId)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function updateUser(userId, data){
			return $http.put('/api/user/' + userId, data)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function updateUserRegister(userId, data){
			return $http.put('/api/register/' + userId, data)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function updatePermissions(data){
			return $http.post('/user-permission', data)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function attachRole(data){
			return $http.post('/api/user-attach-role', data)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function detachRole(data){
			return $http.post('/api/user-detach-role', data)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function attachUserToParent(data){
			return $http.post('/api/attach-user-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function detachUserFromParent(data){
			return $http.post('/api/detach-user-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function deleteUser(userId, data){
			return $http.delete('/api/user/' + userId)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getUnassociatedUsersByParent(parentId,parentType){
			return $http.get('/api/unassociated-users-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getAllUsersByRole(roleName){
            return $http.get('/api/all-users-by-role/' + roleName )
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('WorkflowService', WorkflowService)
	WorkflowService.$inject = ['$http']
	function WorkflowService($http){
		var service = {
			getAllWorkflowsByParent:getAllWorkflowsByParent,
			getAllWorkflowsByProperty:getAllWorkflowsByProperty,
			getWorkflowsByScope:getWorkflowsByScope,
			getAllWorkflows:getAllWorkflows,
			getWorkflow:getWorkflow,
			addWorkflow:addWorkflow,
			attachWorkflowToParent:attachWorkflowToParent,
			detachWorkflowFromParent:detachWorkflowFromParent,
			updateWorkflow:updateWorkflow,
			deleteWorkflow:deleteWorkflow
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/
		function getAllWorkflowsByParent(parentId,parentType){
			return $http.get('/api/workflows-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getAllWorkflowsByProperty(propertyName,propertyValue){
			return $http.get('/api/workflows-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getWorkflowsByScope(scopeName, count, queryParam, queryParam1) {
			var url = '/api/workflows-by-scope/' + scopeName;
			if ((count != undefined) && (count != '')) {
				url = url + '/' + count;
			}
			if ((queryParam != undefined) && (queryParam != '')) {
				url = url + '/' + queryParam;
			}
			if ((queryParam1 != undefined) && (queryParam1 != '')) {
				url = url + '/' + queryParam1;
			}
			return $http.get(url)
			.then(function (response) {
				if (response.status == 200) {
					return response.data.payload;
				} else {
					console.error("ERROR, Non-200 status received in getWorkflowsByScope: ", response);
				}
			})
			.catch(function (err) {
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllWorkflows(q,count){
			q = q || "";
			count = count || 1000;
			var url = '/api/all-workflows';
			if ((count != '')&&(q != '')) {
				url = url + '/' + q + '/' + count;
			}else if (q != '') {
				url = url + '/' + q;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function getWorkflow(workflowId){
			return $http.get('/api/workflow/' + workflowId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function addWorkflow(data){
			return $http.post('/api/workflow', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};

		function updateWorkflow(workflowId, data){
			return $http.put('/api/workflow/' + workflowId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};


		function attachWorkflowToParent(data){
			return $http.post('/api/attach-workflow-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function detachWorkflowFromParent(data){
			return $http.post('/api/detach-workflow-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function deleteWorkflow(workflowId, data){
			return $http.delete('/api/workflow/' + workflowId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});

		};
	}
})();

//# sourceMappingURL=services.js.map
